module.exports = __webpack_public_path__ + "img/newfranquicia.f72bfb07.png";